import styled from '@emotion/styled';
import { Avatar, Box, Typography, TypographyProps } from '@mui/material';
import { componentColors, primaryPalette } from '../../theme';

interface MainContainerProps {
  isMobile?: boolean;
}

export const MainContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isMobile",
}) <MainContainerProps>`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;
  padding-bottom: ${({ isMobile }) => (isMobile ? "16px" : "24px")};
`;

export const HomeTitleSection = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

export const LogoImage = styled(Box) <React.ImgHTMLAttributes<HTMLImageElement>>`
  width: clamp(150px, 30vw, 400px);
  height: auto;
`

export const ToopbrawlTitleContainer = styled(Box)`
  z-index: 1;
  position: absolute;
  bottom: -15px;
`

export const TitleTopbrawl = styled(Typography)`
  color: ${primaryPalette[50]};
  font-size: clamp(2.5rem, 8vw, 6rem);
  text-shadow: 4px 4px black;
  text-align: center;
`

export const MainTitle = styled(Typography) <TypographyProps>`
  font-size: clamp(2em, 5vw, 2.5em);
  text-shadow: 4px 4px black;
  text-align: center;
  padding-top: 16px;
`

export const MainDescription = styled(Typography)`
  text-align: center;
  padding-top: 8px;
`

export const SecondarySection = styled(Box)`
  display: flex;
  flex-direction: column; 
  gap: 32px; 
  padding-top: 32px;
`

export const CardContent = styled(Box)`
 padding: 16px; 
 height: 100%;  
 display: flex; 
 flex-direction: column;
 align-items: stretch; 
 flex: 1;
 max-width: 900px; 
`

export const CardTitle = styled(Typography) <TypographyProps>`
  font-size: 1.5em;
  text-shadow: 2px 2px black;
`

export const CardImageContainer = styled(Box)`
  display: flex; 
  flex-direction: column;
  justify-content: center; 
  align-items: center; 
  padding-top: 16px;
`
export const RankedsImage = styled(Box) <React.ImgHTMLAttributes<HTMLImageElement>>`
  width: 80vw; 
  max-width: 600px;
  height: auto; 
  padding-top: 16px;
`

interface AvatarStyledProps {
  backgroundColor?: string;
}


export const AvatarStyled = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== "backgroundColor",
}) <AvatarStyledProps>`
  background-color: ${({ backgroundColor }) => backgroundColor || componentColors.card};
  height: 20vw;
  width: 20vw;
  max-width: 140px;
  max-height: 140px;
`;

export const AvatarModeStyled = styled(AvatarStyled) <AvatarStyledProps>`
    & img {
    object-fit: contain;
    width: 80%;
    height: 80%;
  }
`